// src/pages/DashboardPage.tsx
import RussiaMap from "@/components/RussiaMap"

export default function DashboardPage() {
  return (
    <div className="p-10 min-h-screen">
      <h1 className="text-5xl font-bold text-white mb-12 text-center bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
        Дашборд ОРВ ВСКС
      </h1>
      <RussiaMap />
      <div className="mt-16 text-center text-purple-300 text-xl">
        Наведите курсор на регион для просмотра информации
      </div>
    </div>
  )
}